import React, { useState, useEffect } from "react";
import { Card, CardBody, CardTitle, Spinner } from "reactstrap";
import { Link } from "react-router-dom";

const ActivityComp = () => {
  const [activities, setActivities] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // 1. ADMİN VE KULLANICI KONTROLÜ
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const isAdmin = authUser?.Users_Type_ID === 3; // 3: Admin
  const userId = authUser?.ID;

  useEffect(() => {
    const fetchActivities = async () => {
      try {
        // 2. YETKİYE GÖRE URL OLUŞTURMA
        // Admin değilse sadece kendi ID'sine ait aktiviteleri filtrele
        const filterQuery = isAdmin ? "" : `$filter=Users_ID eq ${userId}&`;
        const url = `https://hiflowapi.stechomeyazilim.info/Advert_DeliveryStatus?${filterQuery}$orderby=Created_DateTime desc&$top=5&$expand=Users`;

        const response = await fetch(url);
        const result = await response.json();

        if (result && result.value) {
          const formattedData = result.value.map((item, index) => {
            
            // 3. SAAT BİLGİSİNİ EKLEME
            const dateObj = item.Created_DateTime ? new Date(item.Created_DateTime) : new Date();
            // "14 Mar 14:30" formatına çeviriyoruz
            const dateStr = dateObj.toLocaleDateString('tr-TR', { 
                day: '2-digit', 
                month: 'short',
                hour: '2-digit',
                minute: '2-digit'
            });
            
            const userName = item.Users ? item.Users.Users_NameSurname : "Sistem";
            const status = item.Advert_DeliveryStatus_Status || "Güncellendi";
            const advertId = item.Advert_ID || "Bilinmiyor";

            return {
              id: item.ID,
              date: dateStr,
              activity: `${userName}, #${advertId} numaralı taşımanın durumunu güncelledi: ${status}`,
              active: index === 0 // En üstteki aktiviteyi vurgulu yapıyoruz
            };
          });

          setActivities(formattedData);
        }
      } catch (error) {
        console.error("Aktiviteler çekilirken hata oluştu:", error);
      } finally {
        setIsLoading(false);
      }
    };

    // userId varsa veya adminse sorguyu çalıştır (güvenlik çemberi)
    if (isAdmin || userId) {
        fetchActivities();
    } else {
        setIsLoading(false); // Oturum yoksa boşa dönmesin
    }
  }, [isAdmin, userId]);

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle className="mb-5">Son Aktiviteler</CardTitle>
          
          {isLoading ? (
            <div className="text-center py-4">
              <Spinner color="primary" size="sm" /> <span className="ms-2">Yükleniyor...</span>
            </div>
          ) : activities.length > 0 ? (
            <ul className="verti-timeline list-unstyled">
              {activities.map((item) => (
                <li className={`event-list ${item.active ? "active" : ""}`} key={item.id}>
                  <div className="event-timeline-dot">
                    <i className={`font-size-18 bx ${item.active ? "bxs-right-arrow-circle bx-fade-right" : "bx-right-arrow-circle"}`} />
                  </div>
                  <div className="flex-shrink-0 d-flex">
                    <div className="me-3">
                      {/* Saat bilgisini daha iyi vurgulamak için div yapısını hafif güncelledik */}
                      <div className="font-size-14 fw-medium">
                        {item.date}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <div className="text-muted">{item.activity}</div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <div className="text-muted text-center py-3">Henüz bir aktivite bulunmuyor.</div>
          )}

          <div className="text-center mt-4">
            <Link to="/gezilerim" className="btn btn-primary waves-effect waves-light btn-sm">
              Tümünü Gör <i className="mdi mdi-arrow-right ms-1" />
            </Link>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default ActivityComp;